module.exports = __webpack_public_path__ + "img/sleep.1b9988fc.png";